import { ReactiveController, ReactiveControllerHost } from 'lit';
import { Theme } from './types';
export class ThemeController implements ReactiveController {
  host: ReactiveControllerHost;
  theme: Theme;

  constructor(h: ReactiveControllerHost) {
    (this.host = h).addController(this);
    this.theme = Theme.AUTO// Default theme
  }

  setTheme(theme: Theme) {
    this.theme = theme;
    this.applyTheme();
    this.host.requestUpdate();
  }

  applyTheme() {
    document.documentElement.setAttribute('theme', this.theme);
  }

  hostConnected() {
    this.applyTheme();
  }
}
